import { Component, DestroyRef, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FreemiumService } from '../../../services/freemium.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'app-trial-step-four',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trial-step-four.component.html',
  styleUrl: './trial-step-four.component.scss',
})
export class TrialStepFourComponent {
  private freemiumService = inject(FreemiumService);
  private destroyRef = inject(DestroyRef);
  private utilService = inject(UtilService);

  @Input() firstName = '';
  @Input() email = '';

  isResending = false;

  onResendEmail(): void {
    if (this.isResending || !this.email) {
      return;
    }

    this.isResending = true;
    this.freemiumService.sendPasswordResetEmail(this.email)
      .pipe(
        this.utilService.retryWithCondition(() => true),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: () => {
          this.isResending = false;
        },
        error: () => {
          this.isResending = false;
        }
      });
  }
}
